import { render, staticRenderFns } from "./breadcrumb_item.vue?vue&type=template&id=34ac08c6"
import script from "./breadcrumb_item.vue?vue&type=script&lang=js"
export * from "./breadcrumb_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports